// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__2bqDD","active":"Uploader_active__23MJs"};